//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import layer from "@/components/layer/layer.vue";
export default {
	name: "inform",
	data() {
		return {};
	},
	props: {
		processTips: {
			type: String,
			default: "",
		},
	},
	components: {
		layer,
	},
	mounted() {
		const _this = this;
		// 捕获富文本客户告知书点击事件 并添加埋点
		document
			.getElementById("html_inform")
			.addEventListener("click", function() {
				// 兼容处理
				var target = event.target || event.srcElement;
				// 判断是否匹配目标元素
				if (
					target.nodeName.toLocaleLowerCase() === "a" &&
					target.innerHTML == "查看告知书"
				) {
					console.log("当前点击的 a 标签: ", target);
					// 对捕获到的 a 标签进行处理，需要先禁止它的跳转行为
					if (event.preventDefault) {
						event.preventDefault();
						// 添加埋点
						_this.STATISTICS_CONFIG.insur_firstinfo_clause_click();
					} else {
						window.event.returnValue = true;
					}

					// 处理完 a 标签的内容，重新触发跳转，根据原来 a 标签页 target 来判断是否需要新窗口打开
					const url = `${encodeURIComponent(
						target.getAttribute("href")
					)}`;
					_this.$router.push({
						path: "/webpdf",
						query: {
							file: url
						},
						flag: "postdisable",
					});
				}
			});
	},
	methods: {
		close() {
			this.$emit("close");
		},
		btnClick() {
			// 温馨提示点击事件埋点
			this.STATISTICS_CONFIG.insur_firstinfo_submit_click();
			this.$emit("btnClick");
		},
	},
};
